module.exports = __webpack_public_path__ + "static/media/welcome3.cea9c593.png";